<div class="mct-flex mct-row mct-wrap mct-gap-80">
  <div class="mct-flex mct-col mct-gap-20 mct-flex-1-0-300px">
    <div class="mct-flex mct-col mct-gap-20" *ngIf="!value.OrgInd">
      <div>
        <label>{{ 'common.personal-information.prefix' | translate | titlecase }}</label>
        <input class="form-control" type="text" [(ngModel)]="value.Prefix" />
      </div>
      <div>
        <label>{{ 'common.personal-information.first-name' | translate | titlecase }}</label>
        <input data-cy="inputEditProfileFirstName" class="form-control" type="text" [(ngModel)]="value.FirstName" wlTrimInput />
      </div>
      <div>
        <label>{{ 'common.personal-information.middle-initial' | translate | titlecase }}</label>
        <input class="form-control" type="text" [(ngModel)]="value.Mi" />
      </div>
      <div>
        <label>{{ 'common.personal-information.last-name' | translate | titlecase }}</label>
        <input data-cy="inputEditProfileLastName" class="form-control" type="text" [(ngModel)]="value.LastName" wlTrimInput />
      </div>
      <div>
        <label>{{ 'common.personal-information.suffix' | translate | titlecase }}</label>
        <input class="form-control" type="text" [(ngModel)]="value.Suffix" />
      </div>
      <div *ngIf="!value.OrgInd">
        <label>{{ 'common.personal-information.pronouns' | translate | titlecase }}</label>
        <input class="form-control" type="text" [(ngModel)]="value.Pronouns" />
      </div>
    </div>
    <div *ngIf="value.OrgInd">
      <label>{{ 'common.personal-information.organization-name' | translate | titlecase }}</label>
      <input class="form-control" type="text" [(ngModel)]="value.OrgName" wlTrimInput />
    </div>
    <div>
      <label>{{ 'common.personal-information.report-name' | translate | titlecase }}</label>
      <input class="form-control" type="text" [(ngModel)]="value.ReportName" wlTrimInput />
    </div>
    <div>
      <label>{{ 'profiles.sort-name' | translate | titlecase }}</label>
      <input class="form-control" type="text" [(ngModel)]="value.ASF" wlTrimInput />
    </div>
    <div *ngIf="!value.OrgInd">
      <label>{{ 'common.personal-information.title' | translate | titlecase }}</label>
      <input class="form-control" type="text" [(ngModel)]="value.Title" />
    </div>
    <div>
      <p-checkbox [(ngModel)]="inheritAddress" (onChange)="toggleInheritAddress()" [binary]="true"></p-checkbox>
      <label style="margin-left: 5px">{{ 'profiles.edit.general-information.inherit-address' | translate | titlecase }}</label>
      <p-select
        *ngIf="inheritAddress && !updatingRelatedProfileItems"
        required
        name="inheritAddressFromDropdown"
        [(ngModel)]="value.InheritAddressFrom"
        [options]="relatedProfileItems"
        [style]="{ width: '100%' }"
      ></p-select>
    </div>
    <div>
      <label>{{ 'common.personal-information.address' | translate | titlecase }}</label>
      <input class="form-control" type="text" [disabled]="inheritAddress" [(ngModel)]="value.Address1" />
      <input class="form-control mt-5" type="text" [disabled]="inheritAddress" [(ngModel)]="value.Address2" />
    </div>
    <div class="flex row-collapse no-wrap space-between gap-5px">
      <div class="flex column profile-city">
        <label>{{ 'common.personal-information.city' | translate | titlecase }}</label>
        <input class="form-control" type="text" [disabled]="inheritAddress" [(ngModel)]="value.City" />
      </div>
      <div class="flex column profile-state">
        <div>
          <label>{{ 'profiles.edit.general-information.state' | translate }}</label>
        </div>
        <wl-state-selector-modern [(selectedState)]="value.State" [disabled]="inheritAddress"></wl-state-selector-modern>
      </div>
      <div class="flex column profile-zip">
        <label>{{ 'profiles.edit.general-information.zip' | translate }}</label>
        <input class="form-control" type="text" [disabled]="inheritAddress" [(ngModel)]="value.Zip" />
      </div>
      <div class="flex column profile-zip-ext">
        <div style="white-space: nowrap">
          <label style="overflow-y: visible">{{ 'common.personal-information.zipext' | translate | titlecase }}</label>
        </div>
        <input class="form-control" type="text" [disabled]="inheritAddress" [(ngModel)]="value.ZipExt" />
      </div>
    </div>
    <div>
      <label>{{ 'common.personal-information.county' | translate | titlecase }}</label>
      <input class="form-control" type="text" [disabled]="inheritAddress" [(ngModel)]="value.County" />
    </div>
    <div>
      <label>{{ 'common.personal-information.country' | translate | titlecase }}</label>
      <input class="form-control" type="text" [disabled]="inheritAddress" [(ngModel)]="value.Country" />
    </div>
    <div>
      <label>{{ 'common.personal-information.email' | translate | titlecase }}</label>
      <input data-cy="inputEditProfileEmail" class="form-control" type="text" [(ngModel)]="value.Email" wlTrimInput />
    </div>
    <div>
      <label>{{ 'common.personal-information.website' | translate | titlecase }}</label>
      <input class="form-control" type="text" [(ngModel)]="value.Website" />
    </div>
    <div>
      <p-checkbox [(ngModel)]="inheritPhone" (onChange)="toggleInheritPhone()" [binary]="true"></p-checkbox>
      <label style="margin-left: 5px">{{ 'profiles.edit.general-information.inherit-phone' | translate | titlecase }}</label>
      <p-select
        *ngIf="inheritPhone && !updatingRelatedProfileItems"
        required
        name="inheritPhoneFromDropdown"
        [(ngModel)]="value.InheritPhoneFrom"
        [options]="relatedProfileItems"
        [style]="{ width: '100%' }"
      ></p-select>
    </div>
    <div>
      <label>{{ 'common.personal-information.default-phone' | translate | titlecase }}</label>
      <p-select
        [autofocus]="false"
        name="defaultPhoneFromDropdown"
        [(ngModel)]="value.PhoneDefault"
        [options]="defaultPhoneItems"
        [style]="{ width: '100%' }"
      ></p-select>
    </div>
    <div>
      <label>{{ 'common.personal-information.work-phone' | translate | titlecase }}</label>
      <input class="form-control" type="text" [disabled]="inheritPhone" [(ngModel)]="value.WorkPhone" />
    </div>
    <div>
      <label>{{ 'common.personal-information.work-ext' | translate | titlecase }}</label>
      <input class="form-control" type="text" [disabled]="inheritPhone" [(ngModel)]="value.Ext" />
    </div>
    <div>
      <label>{{ 'common.personal-information.home-phone' | translate | titlecase }}</label>
      <input class="form-control" type="text" [disabled]="inheritPhone" [(ngModel)]="value.HomePhone" />
    </div>
    <div>
      <label>{{ 'common.personal-information.fax' | translate | titlecase }}</label>
      <input class="form-control" type="text" [disabled]="inheritPhone" [(ngModel)]="value.Fax" />
    </div>
    <div>
      <label>{{ 'common.personal-information.cell-phone' | translate | titlecase }}</label>
      <input class="form-control" type="text" [(ngModel)]="value.CellPhone" />
    </div>
    <div>
      <label>{{ 'common.personal-information.dba-name' | translate }}</label>
      <input class="form-control" type="text" [(ngModel)]="value.DBA" />
    </div>
    <div>
      <label>{{ 'common.personal-information.preferred-billing-method' | translate | titlecase }}</label>
      <select class="form-control" type="text" [(ngModel)]="value.PreferredBillingMethod">
        <option>
          {{ 'revenue.invoice-selector.form.invoice-info.prefered-bililng-method-options.email-label' | translate | titlecase }}
        </option>
        <option>
          {{ 'revenue.invoice-selector.form.invoice-info.prefered-bililng-method-options.print-label' | translate | titlecase }}
        </option>
        <option>
          {{ 'revenue.invoice-selector.form.invoice-info.prefered-bililng-method-options.both-label' | translate | titlecase }}
        </option>
        <option>
          {{ 'revenue.invoice-selector.form.invoice-info.prefered-bililng-method-options.special-handling-label' | translate | titlecase }}
        </option>
      </select>
    </div>
    <div *wlAccessControl="detailsAccessControl">
      <label>{{ 'profiles.edit.general-information.number-employees-ft' | translate | titlecase }}</label>
      <input class="form-control" type="number" [(ngModel)]="value.EmployeesFT" [min]="0" />
    </div>
    <div *wlAccessControl="detailsAccessControl">
      <label>{{ 'profiles.edit.general-information.number-employees-pt' | translate | titlecase }}</label>
      <input class="form-control" type="number" [(ngModel)]="value.EmployeesPT" [min]="0" />
    </div>
    <div class="mct-flex mct-col" *wlAccessControl="detailsAccessControl">
      <label>{{ 'profiles.edit.general-information.birthdate' | translate | titlecase }}</label>
      <wl-date-selector name="BirthDate" [(ngModel)]="value.BirthDate"></wl-date-selector>
    </div>
    <div class="mct-flex mct-col" *wlAccessControl="detailsAccessControl">
      <label>{{ 'common.personal-information.tax-id' | translate }}</label>
      <input class="form-control" type="text" [(ngModel)]="value.TaxID" />
    </div>
    <div class="mct-flex mct-col" *wlAccessControl="detailsAccessControl">
      <label>{{ 'profiles.change-requests.property-translations.customers' | translate | titlecase }}</label>
      <input class="form-control" type="text" [(ngModel)]="value.Customers" />
    </div>
    <div *ngIf="useProfileExternalId">
      <label>{{ profileExternalIdName }}</label>
      <input class="form-control" type="text" [(ngModel)]="value.ExternalId" />
    </div>
  </div>
  <div class="mct-flex mct-col mct-gap-20 mct-flex-1-0-300px">
    <div>
      <label>{{ 'profiles.edit.general-information.profile-status' | translate | titlecase }}</label>
      <select class="form-control" type="text" [(ngModel)]="value.CustStatus">
        <option>{{ 'common.none' | translate | titlecase }}</option>
        <option *ngFor="let profileStatus of profileStatuses" [value]="profileStatus.MemberType1">{{ profileStatus.MemberType1 }}</option>
      </select>
    </div>
    <div *wlAccessControl="detailsAccessControl">
      <label>{{ 'profiles.edit.general-information.assigned-to' | translate | titlecase }}</label>
      <select class="form-control" type="text" [(ngModel)]="value.AssignedTo">
        <option>{{ 'common.none' | translate | titlecase }}</option>
        <option *ngFor="let user of allUsers" [hidden]="user.Inactive && user.UserNum != value.AssignedTo" [value]="user.UserNum">
          {{ user.UserName }}
        </option>
      </select>
    </div>
    <div *wlAccessControl="detailsAccessControl">
      <label>{{ 'profiles.edit.general-information.sold-by' | translate | titlecase }}</label>
      <select class="form-control" type="text" [(ngModel)]="value.SoldBy">
        <option>{{ 'common.none' | translate | titlecase }}</option>
        <option *ngFor="let user of allUsers" [hidden]="user.Inactive && user.UserNum != value.SoldBy" [value]="user.UserNum">
          {{ user.UserName }}
        </option>
      </select>
    </div>
    <div>
      <p-checkbox [(ngModel)]="value.Prospect" [binary]="true" [disabled]="value.Member"></p-checkbox>
      <label style="margin-left: 5px">{{ 'profiles.edit.general-information.prospect' | translate | titlecase }}</label>
    </div>
    <div *wlAccessControl="detailsAccessControl">
      <label style="margin-left: 5px">
        {{ 'profiles.edit.general-information.email-subscription-status' | translate | titlecase }}
      </label>

      <div class="mct-flex mct-col mct-gap-10">
        <div class="radio-option">
          <p-radioButton name="emailSubscription" inputId="optIn" [(ngModel)]="value.NoEmail" [value]="false"> </p-radioButton>
          <label for="optIn" [innerHTML]="'profiles.edit.general-information.email-subscription-status-opted-in' | translate"></label>
        </div>
        <div class="radio-option">
          <p-radioButton name="emailSubscription" inputId="optOut" [(ngModel)]="value.NoEmail" [value]="true"> </p-radioButton>
          <label for="optOut" [innerHTML]="'profiles.edit.general-information.email-subscription-status-opted-out' | translate"></label>
        </div>
      </div>
    </div>
  </div>
</div>
